import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  Card,
  CardContent
} from "@mui/material";

import api from "../../api/api";

export default function HolidayCalendar() {

  const [rows, setRows] = useState([]);

  const [form, setForm] = useState({
    date: "",
    name: ""
  });

  useEffect(() => {
    loadData();
  }, []);

  // ============================
  // LOAD HOLIDAYS
  // ============================

  const loadData = async () => {

    try {

      const res = await api.get("/holidays");

      setRows(res.data);

    } catch (error) {

      console.error("Error loading holidays", error);

    }

  };

  // ============================
  // ADD HOLIDAY
  // ============================

  const addHoliday = async () => {

    try {

      await api.post("/holidays", form);

      loadData();

      setForm({
        date: "",
        name: ""
      });

    } catch (error) {

      console.error("Add holiday failed", error);

    }

  };

  return (

    <Box p={4}>

      <Typography variant="h5" mb={3}>
        Holiday Calendar
      </Typography>

      <Card sx={{ mb: 3 }}>

        <CardContent>

          <TextField
            type="date"
            value={form.date}
            onChange={(e) =>
              setForm({ ...form, date: e.target.value })
            }
            sx={{ mr: 2 }}
          />

          <TextField
            label="Holiday Name"
            value={form.name}
            onChange={(e) =>
              setForm({ ...form, name: e.target.value })
            }
            sx={{ mr: 2 }}
          />

          <Button
            variant="contained"
            onClick={addHoliday}
          >
            Add Holiday
          </Button>

        </CardContent>

      </Card>

      <Table>

        <TableHead>

          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Name</TableCell>
          </TableRow>

        </TableHead>

        <TableBody>

          {rows.map((r) => (

            <TableRow key={r.id}>

              <TableCell>{r.date}</TableCell>
              <TableCell>{r.name}</TableCell>

            </TableRow>

          ))}

        </TableBody>

      </Table>

    </Box>

  );

}